export enum PublicSharingType {
    VIEW        = 1,    // default (for old view)
    PROJECT     = 2,    // for custom shared view in structure
}

export type SharedViewConfig = {
    projectId?              : ID        // for project view share
    projectCollectionId?    : ID        // for portfolio view share
    viewId?                 : ID        // for project or portfolio view share
    customViewId?           : ID        // for custom view share

    openTasks?              : boolean
    openEvents?             : boolean
    openDocs?               : boolean

    expirationDate?         : string    // date string of YYYY-MM-DD format
}